module.exports = __webpack_public_path__ + "img/homefooter_icon05.70369fe1.jpg";